import React from "react";

export default () => (
  <svg
    width="14px"
    height="14px"
    viewBox="0 0 14 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="Symbols"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <g
        id="lg-/-Grid-/-Items"
        transform="translate(-601.000000, -550.000000)"
        fill="#004B87"
      >
        <g id="Icon/Info" transform="translate(598.000000, 547.000000)">
          <path
            d="M10,3.33333333 C6.33333333,3.33333333 3.33333333,6.33333333 3.33333333,10 C3.33333333,13.6666667 6.33333333,16.6666667 10,16.6666667 C13.6666667,16.6666667 16.6666667,13.6666667 16.6666667,10 C16.6666667,6.33333333 13.6666667,3.33333333 10,3.33333333 Z M10.8333333,13.3333333 L9.16666667,13.3333333 L9.16666667,9.16666667 L10.8333333,9.16666667 L10.8333333,13.3333333 Z M10,8.33333333 C9.5,8.33333333 9.16666667,8 9.16666667,7.5 C9.16666667,7 9.5,6.66666667 10,6.66666667 C10.5,6.66666667 10.8333333,7 10.8333333,7.5 C10.8333333,8 10.5,8.33333333 10,8.33333333 Z"
            id="Fill"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);
